import { useReactive } from 'gyron'

export const storeState = useReactive({
  guidance: {},
})
